import { render, staticRenderFns } from "./Deal.vue?vue&type=template&id=8232ecb6&"
import script from "./Deal.vue?vue&type=script&lang=js&"
export * from "./Deal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8232ecb6')) {
      api.createRecord('8232ecb6', component.options)
    } else {
      api.reload('8232ecb6', component.options)
    }
    module.hot.accept("./Deal.vue?vue&type=template&id=8232ecb6&", function () {
      api.rerender('8232ecb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Calculators/HomeVantage/Summaries/Tabs/Deal.vue"
export default component.exports